<div class="callout callout-{{ type }}" [ngClass]="{'d-none': !isVisible, 'only-text': !header, 'd-flex': !header, 'align-items-center': !header}" *ngIf="this.isVisible">
    <object *ngIf="icon" data="../../../../assets/images/material-lightbulb-outline.svg" class="d-inline-block icon mr-2"></object>
    <h3 class="callout-heading d-inline-block" *ngIf="header">{{ header }}</h3>
    <p class="callout-body mb-0 d-inline-block">{{ text }}</p>
    <button mat-button class="close-btn" (click)="close()">
        <span class="material-icons">
            close
        </span>
    </button>
</div>